export const dimensions = () => {
    const width = window.innerWidth;
    const height = width * 0.57125;
    return { width, height };
}